import React, { useState, useEffect } from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function FloatingWhatsApp() {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    fetchSiteSettings();
  }, []);

  const fetchSiteSettings = async () => {
    try {
      const res = await fetch(`${API}/site-settings`);
      if (res.ok) setSiteSettings(await res.json());
    } catch (error) {
      console.error('Error fetching site settings:', error);
    }
  };

  const siteName = siteSettings?.site_name || 'SP BD Group';
  const contact = siteSettings?.contact || {};
  const whatsappNumber = contact.whatsapp || contact.phone || "+880 1234-567890";
  const whatsappMessage = `Hello ${siteName}, I'd like to inquire about your services...`;
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" className="group-hover:scale-110 transition-transform" />
      
      <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block">
        <div className="bg-gray-900 text-white text-sm px-3 py-2 rounded-sm whitespace-nowrap shadow-lg">
          Chat with us on WhatsApp
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
        </div>
      </div>

      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#FF3B3B] rounded-full animate-pulse"></span>
    </a>
  );
}
